import AppContainer from "../Structure/AppContainer";
import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import toast, { Toaster } from "react-hot-toast";
import AuthContext from "../../Context/AuthContext";
import { useNavigate } from "react-router-dom";
import useStateCallback from "../../util/customHooks/useStateCallback";
import ajaxDeliveries from "../../util/remote/ajaxDeliveries";
import { useFilter } from "../../Context/FilterContext";
import RegisterDeliveryModal from "./RegisterDeliveryModal";
const ViewFuelDeliveries = () => {
  const { toggleFilter, filterVisible } = useFilter();
  const itemsPerPageOptions = [
    { value: 10, label: "10" },
    { value: 25, label: "25" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];
  const { userId } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [deliveriesList, setDeliveriesList] = useState([]);
  const [meta, setMeta] = useState([]);
  const [page, setPage] = useState(1);
  const [viewType, setViewType] = useState("table view");
  const [search, setSearch] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(10);
  // Fetch Deliveries
  const fetchDeliveries = async () => {
    setLoading(true);
    const data = {
      page,
      items_per_page: itemsPerPage,
      search: search || null,
    };
    const response = await ajaxDeliveries.listDeliveries(data);
    if (response.status === "OK") {
      setDeliveriesList(response.details.list || []);
      setMeta(response.details.meta?.list_of_pages || []);
    } else {
      toast.error(response.message);
    }
    setLoading(false);
  };
  useEffect(() => {
    fetchDeliveries();
  }, [page, search, itemsPerPage]);
  const [Registers, setRegisters] = useStateCallback(false);
  const handleRegister = () => {
    setRegisters(false, () =>
      setRegisters(<RegisterDeliveryModal func={fetchDeliveries} />)
    );
  };
  const toggleView = (type) => setViewType(type);
  const setNextPageNumber = () => page < meta.length && setPage(page + 1);
  const setPreviousPageNumber = () => page > 1 && setPage(page - 1);
  const setPageNumber = (e, item) => {
    e.preventDefault();
    setPage(item);
  };
  const filteredActions = [
    {
      label: "Register Delivery",
      icon: "fa-solid fa-file-pen",
      className: "btn btn-primary btn-sm",
      onClick: () => handleRegister(),
    },
    {
      label: "card view",
      icon: "fa-regular fa-address-card",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("card view"),
    },
    {
      label: "table view",
      icon: "fa-solid fa-table",
      className: "btn btn-success btn-sm",
      onClick: () => toggleView("table view"),
    },
    {
      label: "filter",
      icon: "fa-solid fa-filter",
      className: "btn btn-warning btn-sm",
      onClick: () => toggleFilter(),
    },
  ].filter((action) => action.label !== viewType);
  return (
    <AppContainer
      title="Fuel Deliveries"
      previousPageTitle="Dashboard"
      actions={filteredActions}
    >
      <div className="container-fluid">
        <Toaster />
        {Registers}
        {/* Filter Section */}
        {filterVisible && (
          <div className="row">
            <div className="col-sm-12 col-lg-12 col-xl-12">
              <div className="card shadow-sm border-0 rounded-3">
                <div className="card-body p-4">
                  <div className="bg-light p-3 rounded-3 border mb-3">
                    <div className="row g-3 align-items-end">
                      {/* Items per page */}
                      <div className="col-lg-2">
                        <label className="form-label fw-semibold">
                          Items per page
                        </label>
                        <Select
                          value={itemsPerPageOptions.find(
                            (opt) => opt.value === itemsPerPage
                          )}
                          onChange={(selected) => {
                            setPage(1);
                            setItemsPerPage(selected.value);
                          }}
                          options={itemsPerPageOptions}
                          isSearchable={false}
                        />
                      </div>
                      {/* Apply */}
                      <div className="col-lg-7 d-flex justify-content-end gap-2">
                        <button
                          className="btn btn-primary btn-sm m-2"
                          onClick={fetchDeliveries}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {/* Loading / No Data */}
        {loading ? (
          <div className="text-center my-5 fs-5 text-muted">
            Loading deliveries...
          </div>
        ) : deliveriesList.length === 0 ? (
          <div className="text-center my-5 fs-5 text-muted">
            No deliveries found
          </div>
        ) : viewType === "table view" ? (
          <>
            {/* Table View */}
            <div className="row">
              <div className="col-sm-12 col-xl-12 col-lg-12">
                <div className="card custom-card">
                  <div className="card-body">
                    <div>
                      <h6 className="card-title mb-1">Fuel Deliveries</h6>
                      <p className="text-muted card-sub-title">
                        List of recent fuel deliveries
                      </p>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered text-nowrap mb-0">
                        <thead>
                          <tr>
                            <th>#</th>
                            <th>Truck Plate</th>
                            <th>Fuel Category</th>
                            <th>Tank</th>
                            <th>Quantity (L)</th>
                            <th>Supplier</th>
                            <th>Received By</th>
                            <th>Date Received</th>
                            <th>Status</th>
                          </tr>
                        </thead>
                        <tbody>
                          {deliveriesList.map((item, index) => (
                            <tr key={item.id}>
                              <td>{(page - 1) * itemsPerPage + index + 1}</td>
                              <td>{item.truck_number_plate}</td>
                              <td>{item.fuel_category}</td>
                              <td>{item.Tank_code}</td>
                              <td>{item.quantity}</td>
                              <td>{item.name}</td>
                              <td>
                                {item.first_name} {item.last_name}
                              </td>
                              <td>{item.date_recieved}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    item.status === "1"
                                      ? "bg-success"
                                      : "bg-danger"
                                  }`}
                                >
                                  {item.status === "1"
                                    ? "Completed"
                                    : "Pending"}
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <>
            {/* Card View */}
            <div className="row">
              {deliveriesList.map((item) => (
                <div className="col-md-4 col-lg-3 mb-3" key={item.id}>
                  <div className="card h-100 shadow-sm">
                    <div className="card-body text-center">
                      <h6 className="mb-1">{item.truck_number_plate}</h6>
                      <p className="text-muted mb-1">
                        {item.fuel_category} — {item.quantity}L
                      </p>
                      <small className="d-block text-muted">
                        Tank: {item.Tank_code}
                      </small>
                      <small className="d-block text-muted">
                        Supplier: {item.name}
                      </small>
                      <small className="d-block text-muted">
                        Received By: {item.first_name} {item.last_name}
                      </small>
                      <small className="d-block text-muted">
                        Date: {item.date_recieved}
                      </small>
                      <div className="mt-2">
                        <span
                          className={`badge px-3 py-1 ${
                            item.status === "1" ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {item.status === "1" ? "Completed" : "Pending"}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {/* Pagination */}
        <div className="card-footer">
          <nav className="d-flex justify-content-center">
            <ul className="pagination mb-0">
              <li className="page-item">
                <button className="page-link" onClick={setPreviousPageNumber}>
                  Prev
                </button>
              </li>
              {Array.isArray(meta) &&
                meta.map((item) =>
                  page === item ? (
                    <li className="page-item active" key={item}>
                      <span className="page-link">{item}</span>
                    </li>
                  ) : (
                    <li className="page-item" key={item}>
                      <a
                        className="page-link"
                        href="#"
                        onClick={(e) => setPageNumber(e, item)}
                      >
                        {item}
                      </a>
                    </li>
                  )
                )}
              <li className="page-item">
                <button className="page-link" onClick={setNextPageNumber}>
                  Next
                </button>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </AppContainer>
  );
};
export default ViewFuelDeliveries;
